import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-background-50 text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-2xl bg-background-100">
          <i className="ri-compass-3-line text-3xl text-foreground-300"></i>
        </div>
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">页面未找到</h1>
        <p className="text-sm text-foreground-400 font-mono mb-4">{location.pathname}</p>
        <p className="text-sm md:text-base text-foreground-500 mb-8">你访问的页面可能已被移除，或链接有误。</p>
        <Link
          to="/"
          className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-lg transition-colors"
        >
          <i className="ri-arrow-left-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}